<ui-modal
  class="warning-screen"
  [isOpened]="isModalOpened"
  [modalTitle]="headerMessage"
  (isOpenedChange)="modalChanged($event)"
  size="m"
>
  <!-- <div class="modal-content">{{ messageToDisplay }}</div> -->

  <div class="warning-screen__content">
    <div class="warning-screen__content__body">
      {{ messageToDisplay }}
    </div>

    <div class="warning-screen__content__footer">
      <ng-container *ngIf="yesNoOptions; else understoodOption">
        <button
          class="ui-button ui-button--danger ui-button--no"
          (click)="sendMessage(false)"
        >
          No
        </button>

        <button class="ui-button primary" (click)="sendMessage(true)">
          Yes
        </button>
      </ng-container>

      <ng-template #understoodOption>
        <button class="ui-button primary" (click)="sendMessage(true)">
          Understood
        </button>
      </ng-template>
    </div>
  </div>
</ui-modal>
